import { render, staticRenderFns, recyclableRender, components } from "./PcScrollBar.vue?vue&type=template&id=7c08a95e&scoped=true&"
var renderjs
import script from "./PcScrollBar.vue?vue&type=script&lang=js&"
export * from "./PcScrollBar.vue?vue&type=script&lang=js&"
import style0 from "./PcScrollBar.vue?vue&type=style&index=0&id=7c08a95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08a95e",
  null,
  false,
  components,
  renderjs
)

export default component.exports